<div class="om-select {{ sizeClass() }}">
  <p-select
    [formControl]="control()"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue() || undefined"
    [placeholder]="placeholder()"
    [inputId]="inputId()"
    appendTo="body"
    styleClass="w-full om-select-input"
  >
    <ng-template #selectedItem let-option>
      @if (option) { @if (translateOptionLabel()) {
      <span>{{ getLabel(option) | translate }}</span>
      } @else {
      <span>{{ getLabel(option) }}</span>
      } }
    </ng-template>
    <ng-template #item let-option>
      @if (translateOptionLabel()) {
      <span>{{ getLabel(option) | translate }}</span>
      } @else {
      <span>{{ getLabel(option) }}</span>
      }
    </ng-template>
  </p-select>
</div>
